import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../slice";

function Wait() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let data = window.sessionStorage.getItem("approved_info");
  let message = "";
  if (data) {
    message = JSON.parse(data).message;
  }
  let [title, ...textMessage] = message.split("\r\n");

  useEffect(() => {
    dispatch(setPageTitle(""));
  }, [dispatch]);

  return (
    <Box
      display="flex"
      flexDirection={"column"}
      alignItems="end"
      width={{ xs: "65%", sm: "60%", md: "40%" }}
      bgcolor="#FAFAFA"
      borderRadius={4}
      px={6}
      py={3}
      my={10}
      mx={"auto"}
    >
      <Typography
        variant="h2"
        fontSize="22px"
        fontWeight={600}
        textAlign="right"
        mt={2}
        mb={6}
        sx={{ color: "#4C466F" }}
      >
        {title && title}
      </Typography>
      <Typography
        variant="h2"
        sx={{ direction: "rtl", fontWeight: "400", textAlign: "justify" }}
        paragraph
      >
        {message.length !== 0 && textMessage.join("\r\n")}
      </Typography>
      <Button
        onClick={navigate.bind(this, "/ticketing")}
        variant="m1"
        sx={{ marginTop: "15px", alignSelf: "center" }}
      >
        درخواست پشتیبانی
      </Button>
    </Box>
  );
}

export default Wait;
